export const AUTH_FORCED_SIGN_OUT_EVENT = 'auth:forced-sign-out';

const PRIVATE_SESSION_PREFIXES = ['dashboard_', 'global_'];

export function clearPrivateSessionStorage(storage = typeof window !== 'undefined' ? window.sessionStorage : null) {
  if (!storage) return;

  try {
    Object.keys(storage).forEach((key) => {
      if (PRIVATE_SESSION_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        storage.removeItem(key);
      }
    });
  } catch (_) {
    // Ignore storage access failures.
  }
}
